/**
 * @file Especialização Email do pipeline Input.
 * @module components/create/email
 */

/**
 * Configura input HTML `email` e valida no blur.
 *
 * @param {HTMLInputElement} elem Input base.
 * @param {Object} options Opções recebidas pelo componente.
 * @param {Function} [options.callback] Callback repassado ao validador `checkEmail`.
 * @returns {Array.<HTMLInputElement|Object>} Input e `options` normalizado.
 */
export default (elem, options) => {
  options.type = 'email';

  if (options.callback !== undefined && typeof options.callback === 'function') {
    elem.callback = options.callback;
  }

  elem.addEventListener('blur', (e) => {
    e.target.checkEmail(e.target.callback);
  });

  return [elem, options];
}